import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import darkWebService from "../../services/darkWebService";

export const getDarkWebLastLeaksPageable = createAsyncThunk(
  "darkWeb/getDarkWebLastLeaksPageable",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLastLeaksPageable({
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebUniqueDomainsPageable = createAsyncThunk(
  "darkWeb/getDarkWebUniqueDomainsPageable",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebUniqueDomainsPageable({
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDomainScanHistory = createAsyncThunk(
  "darkWeb/getDarkWebDomainScanHistory",
  async ({ domainName, params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebDomainScanHistory({
        domainName,
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebLeaksPageable = createAsyncThunk(
  "darkWeb/getDarkWebLeaksPageable",
  async ({ darkWebId, params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLeaksPageable({
        darkWebId,
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebLookalikePageable = createAsyncThunk(
  "darkWeb/getDarkWebLookalikePageable",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLookalikePageable({
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebLookalikeUniqueDomainsPageable = createAsyncThunk(
  "darkWeb/getDarkWebLookalikeUniqueDomainsPageable",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLookalikeUniqueDomainsPageable({
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebLookalikeScanHistory = createAsyncThunk(
  "darkWeb/getDarkWebLookalikeScanHistory",
  async ({ domainName, params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLookalikeScanHistory({
        domainName,
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebLookalikeItemsPageable = createAsyncThunk(
  "darkWeb/getDarkWebLookalikeItemsPageable",
  async ({ lookalikeId, params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLookalikeItemsPageable({
        lookalikeId,
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getThirdPartyDbPageable = createAsyncThunk(
  "darkWeb/getThirdPartyDbPageable",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getThirdPartyDbPageable({
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getThirdPartyDbUniqueDomainsPageable = createAsyncThunk(
  "darkWeb/getThirdPartyDbUniqueDomainsPageable",
  async ({ params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getThirdPartyDbUniqueDomainsPageable({
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getThirdPartyDbScanHistory = createAsyncThunk(
  "darkWeb/getThirdPartyDbScanHistory",
  async ({ domainName, params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getThirdPartyDbScanHistory({
        domainName,
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getThirdPartyDbLeaksPageable = createAsyncThunk(
  "darkWeb/getThirdPartyDbLeaksPageable",
  async ({ thirdPartyDbId, params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getThirdPartyDbLeaksPageable({
        thirdPartyDbId,
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getThirdPartyDbLeakAccountsPageable = createAsyncThunk(
  "darkWeb/getThirdPartyDbLeakAccountsPageable",
  async ({ leakId, params, data }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getThirdPartyDbLeakAccountsPageable({
        leakId,
        params,
        data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebLastLeaksHasData = createAsyncThunk(
  "darkWeb/getDarkWebLastLeaksHasData",
  async ({ domainId }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLastLeaksHasData(domainId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebLookalikeHasData = createAsyncThunk(
  "darkWeb/getDarkWebLookalikeHasData",
  async ({ domainId }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebLookalikeHasData(domainId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebThirdPartyDbHasData = createAsyncThunk(
  "darkWeb/getDarkWebThirdPartyDbHasData",
  async ({ domainId }, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDarkWebThirdPartyDbHasData(domainId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDashboardSummary = createAsyncThunk(
  "darkWeb/getDarkWebDashboardSummary",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDashboardSummary(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDashboardLeaksByDataType = createAsyncThunk(
  "darkWeb/getDarkWebDashboardLeaksByDataType",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDashboardLeaksByDataType(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDashboardLeaksByBreachType = createAsyncThunk(
  "darkWeb/getDarkWebDashboardLeaksByBreachType",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDashboardLeaksByBreachType(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDashboardLookalikeByDataType = createAsyncThunk(
  "darkWeb/getDarkWebDashboardLookalikeByDataType",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDashboardLookalikeByDataType(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDashboardThirdPartyDatabases = createAsyncThunk(
  "darkWeb/getDarkWebDashboardThirdPartyDatabases",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDashboardThirdPartyDatabases(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDashboardTopDomainsByLeaks = createAsyncThunk(
  "darkWeb/getDarkWebDashboardTopDomainsByLeaks",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDashboardTopDomainsByLeaks(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDarkWebDashboardActivity = createAsyncThunk(
  "darkWeb/getDarkWebDashboardActivity",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await darkWebService.getDashboardActivity(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  lastLeaksLoading: false,
  lastLeaksData: null,
  lastLeaksError: null,

  uniqueDomainsLoading: false,
  uniqueDomainsData: null,
  uniqueDomainsError: null,

  scanHistoryLoading: false,
  scanHistoryData: null,
  scanHistoryError: null,

  leaksLoading: false,
  leaksData: null,
  leaksError: null,

  lastLeaksPageableRequest: {
    params: {
      page: 0,
      size: 15,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainId: null,
      domainName: "",
    },
  },

  uniqueDomainsPageableRequest: {
    params: {
      page: 0,
      size: 20,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainId: null,
      domainName: "",
      hasLeaks: true,
    },
  },

  scanHistoryPageableRequest: {
    params: {
      page: 0,
      size: 10,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainName: "",
      hasLeaks: true,
    },
  },

  leaksPageableRequest: {
    params: {
      page: 0,
      size: 10,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      dataType: "",
      breachType: "",
      username: "",
      url: "",
      ip: "",
    },
  },

  lookalikeListLoading: false,
  lookalikeListData: null,
  lookalikeListError: null,
  lookalikeListPageableRequest: {
    params: {
      page: 0,
      size: 15,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      id: null,
      domainName: "",
    },
  },

  lookalikeScanHistoryLoading: false,
  lookalikeScanHistoryData: null,
  lookalikeScanHistoryError: null,
  lookalikeScanHistoryPageableRequest: {
    params: {
      page: 0,
      size: 10,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainName: "",
    },
  },

  thirdPartyDbScanHistoryLoading: false,
  thirdPartyDbScanHistoryData: null,
  thirdPartyDbScanHistoryError: null,
  thirdPartyDbScanHistoryPageableRequest: {
    params: {
      page: 0,
      size: 10,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainName: "",
    },
  },

  lookalikeItemsLoading: false,
  lookalikeItemsData: null,
  lookalikeItemsError: null,
  lookalikeItemsPageableRequest: {
    params: {
      page: 0,
      size: 10,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainName: "",
      detectedDomain: "",
      originalEntry: "",
    },
  },

  thirdPartyDbLoading: false,
  thirdPartyDbData: null,
  thirdPartyDbError: null,
  thirdPartyDbPageableRequest: {
    params: {
      page: 0,
      size: 20,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainId: null,
      domainName: "",
    },
  },

  thirdPartyLeaksLoading: false,
  thirdPartyLeaksData: null,
  thirdPartyLeaksError: null,
  thirdPartyLeaksPageableRequest: {
    params: {
      page: 0,
      size: 5,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainName: "",
      databaseName: "",
      email: null,
    },
  },

  thirdPartyAccountsLoading: false,
  thirdPartyAccountsData: null,
  thirdPartyAccountsError: null,
  thirdPartyAccountsPageableRequest: {
    params: {
      page: 0,
      size: 10,
      sort: "createdDate",
      direction: "DESC",
    },
    data: {
      domainName: null,
      databaseName: null,
      email: "",
    },
  },

  hasLastLeaksLoading: false,
  hasLastLeaksExist: null,
  hasLastLeaksError: null,

  hasLookalikeLoading: false,
  hasLookalikeExist: null,
  hasLookalikeError: null,

  hasThirdPartyDbLoading: false,
  hasThirdPartyDbExist: null,
  hasThirdPartyDbError: null,

  dashboardSummary: null,
  dashboardSummaryLoading: false,
  dashboardSummaryError: null,

  dashboardLeaksByDataType: null,
  dashboardLeaksByDataTypeLoading: false,
  dashboardLeaksByDataTypeError: null,

  dashboardLeaksByBreachType: null,
  dashboardLeaksByBreachTypeLoading: false,
  dashboardLeaksByBreachTypeError: null,

  dashboardLookalikeByDataType: null,
  dashboardLookalikeByDataTypeLoading: false,
  dashboardLookalikeByDataTypeError: null,

  dashboardThirdPartyDatabases: null,
  dashboardThirdPartyDatabasesLoading: false,
  dashboardThirdPartyDatabasesError: null,

  dashboardTopDomainsByLeaks: null,
  dashboardTopDomainsByLeaksLoading: false,
  dashboardTopDomainsByLeaksError: null,

  dashboardActivity: null,
  dashboardActivityLoading: false,
  dashboardActivityError: null,
};

export const darkWebSlice = createSlice({
  name: "darkWeb",
  initialState,
  reducers: {
    clearLeaksData: (state) => {
      state.leaksData = null;
      state.leaksError = null;
      state.leaksLoading = false;
    },
    clearScanHistoryData: (state) => {
      state.scanHistoryData = null;
      state.scanHistoryError = null;
      state.scanHistoryLoading = false;
    },
    clearLookalikeItemsData: (state) => {
      state.lookalikeItemsData = null;
      state.lookalikeItemsError = null;
      state.lookalikeItemsLoading = false;
    },
    clearLookalikeScanHistoryData: (state) => {
      state.lookalikeScanHistoryData = null;
      state.lookalikeScanHistoryError = null;
      state.lookalikeScanHistoryLoading = false;
    },
    clearThirdPartyDbScanHistoryData: (state) => {
      state.thirdPartyDbScanHistoryData = null;
      state.thirdPartyDbScanHistoryError = null;
      state.thirdPartyDbScanHistoryLoading = false;
    },
    clearThirdPartyLeaksData: (state) => {
      state.thirdPartyLeaksData = null;
      state.thirdPartyLeaksError = null;
      state.thirdPartyLeaksLoading = false;
    },
    clearThirdPartyAccountsData: (state) => {
      state.thirdPartyAccountsData = null;
      state.thirdPartyAccountsError = null;
      state.thirdPartyAccountsLoading = false;
    },
    clearHasDataFlags: (state) => {
      state.hasLastLeaksLoading = false;
      state.hasLastLeaksExist = null;
      state.hasLastLeaksError = null;

      state.hasLookalikeLoading = false;
      state.hasLookalikeExist = null;
      state.hasLookalikeError = null;

      state.hasThirdPartyDbLoading = false;
      state.hasThirdPartyDbExist = null;
      state.hasThirdPartyDbError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDarkWebLastLeaksPageable.pending, (state) => {
      state.lastLeaksLoading = true;
      state.lastLeaksError = null;
    });
    builder.addCase(getDarkWebLastLeaksPageable.fulfilled, (state, action) => {
      state.lastLeaksLoading = false;
      state.lastLeaksData = action.payload;
      state.lastLeaksError = null;
    });
    builder.addCase(getDarkWebLastLeaksPageable.rejected, (state, action) => {
      state.lastLeaksLoading = false;
      state.lastLeaksError = action.payload || action.error;
    });

    builder.addCase(getDarkWebLeaksPageable.pending, (state) => {
      state.leaksLoading = true;
      state.leaksError = null;
    });
    builder.addCase(getDarkWebLeaksPageable.fulfilled, (state, action) => {
      state.leaksLoading = false;
      state.leaksData = action.payload;
      state.leaksError = null;
    });
    builder.addCase(getDarkWebLeaksPageable.rejected, (state, action) => {
      state.leaksLoading = false;
      state.leaksError = action.payload || action.error;
    });

    builder.addCase(getDarkWebUniqueDomainsPageable.pending, (state) => {
      state.uniqueDomainsLoading = true;
      state.uniqueDomainsError = null;
    });
    builder.addCase(getDarkWebUniqueDomainsPageable.fulfilled, (state, action) => {
      state.uniqueDomainsLoading = false;
      state.uniqueDomainsData = action.payload;
      state.uniqueDomainsError = null;
    });
    builder.addCase(getDarkWebUniqueDomainsPageable.rejected, (state, action) => {
      state.uniqueDomainsLoading = false;
      state.uniqueDomainsError = action.payload || action.error;
    });

    builder.addCase(getDarkWebDomainScanHistory.pending, (state) => {
      state.scanHistoryLoading = true;
      state.scanHistoryError = null;
    });
    builder.addCase(getDarkWebDomainScanHistory.fulfilled, (state, action) => {
      state.scanHistoryLoading = false;
      state.scanHistoryData = action.payload;
      state.scanHistoryError = null;
    });
    builder.addCase(getDarkWebDomainScanHistory.rejected, (state, action) => {
      state.scanHistoryLoading = false;
      state.scanHistoryError = action.payload || action.error;
    });

    builder.addCase(getDarkWebLookalikePageable.pending, (state) => {
      state.lookalikeListLoading = true;
      state.lookalikeListError = null;
    });
    builder.addCase(getDarkWebLookalikePageable.fulfilled, (state, action) => {
      state.lookalikeListLoading = false;
      state.lookalikeListData = action.payload;
      state.lookalikeListError = null;
    });
    builder.addCase(getDarkWebLookalikePageable.rejected, (state, action) => {
      state.lookalikeListLoading = false;
      state.lookalikeListError = action.payload || action.error;
    });

    builder.addCase(getDarkWebLookalikeUniqueDomainsPageable.pending, (state) => {
      state.lookalikeListLoading = true;
      state.lookalikeListError = null;
    });
    builder.addCase(getDarkWebLookalikeUniqueDomainsPageable.fulfilled, (state, action) => {
      state.lookalikeListLoading = false;
      state.lookalikeListData = action.payload;
      state.lookalikeListError = null;
    });
    builder.addCase(getDarkWebLookalikeUniqueDomainsPageable.rejected, (state, action) => {
      state.lookalikeListLoading = false;
      state.lookalikeListError = action.payload || action.error;
    });

    builder.addCase(getDarkWebLookalikeScanHistory.pending, (state) => {
      state.lookalikeScanHistoryLoading = true;
      state.lookalikeScanHistoryError = null;
    });
    builder.addCase(getDarkWebLookalikeScanHistory.fulfilled, (state, action) => {
      state.lookalikeScanHistoryLoading = false;
      state.lookalikeScanHistoryData = action.payload;
      state.lookalikeScanHistoryError = null;
    });
    builder.addCase(getDarkWebLookalikeScanHistory.rejected, (state, action) => {
      state.lookalikeScanHistoryLoading = false;
      state.lookalikeScanHistoryError = action.payload || action.error;
    });

    builder.addCase(getDarkWebLookalikeItemsPageable.pending, (state) => {
      state.lookalikeItemsLoading = true;
      state.lookalikeItemsError = null;
    });
    builder.addCase(getDarkWebLookalikeItemsPageable.fulfilled, (state, action) => {
      state.lookalikeItemsLoading = false;
      state.lookalikeItemsData = action.payload;
      state.lookalikeItemsError = null;
    });
    builder.addCase(getDarkWebLookalikeItemsPageable.rejected, (state, action) => {
      state.lookalikeItemsLoading = false;
      state.lookalikeItemsError = action.payload || action.error;
    });

    builder.addCase(getThirdPartyDbPageable.pending, (state) => {
      state.thirdPartyDbLoading = true;
      state.thirdPartyDbError = null;
    });
    builder.addCase(getThirdPartyDbPageable.fulfilled, (state, action) => {
      state.thirdPartyDbLoading = false;
      state.thirdPartyDbData = action.payload;
      state.thirdPartyDbError = null;
    });
    builder.addCase(getThirdPartyDbPageable.rejected, (state, action) => {
      state.thirdPartyDbLoading = false;
      state.thirdPartyDbError = action.payload || action.error;
    });

    builder.addCase(getThirdPartyDbUniqueDomainsPageable.pending, (state) => {
      state.thirdPartyDbLoading = true;
      state.thirdPartyDbError = null;
    });
    builder.addCase(getThirdPartyDbUniqueDomainsPageable.fulfilled, (state, action) => {
      state.thirdPartyDbLoading = false;
      state.thirdPartyDbData = action.payload;
      state.thirdPartyDbError = null;
    });
    builder.addCase(getThirdPartyDbUniqueDomainsPageable.rejected, (state, action) => {
      state.thirdPartyDbLoading = false;
      state.thirdPartyDbError = action.payload || action.error;
    });

    builder.addCase(getThirdPartyDbScanHistory.pending, (state) => {
      state.thirdPartyDbScanHistoryLoading = true;
      state.thirdPartyDbScanHistoryError = null;
    });
    builder.addCase(getThirdPartyDbScanHistory.fulfilled, (state, action) => {
      state.thirdPartyDbScanHistoryLoading = false;
      state.thirdPartyDbScanHistoryData = action.payload;
      state.thirdPartyDbScanHistoryError = null;
    });
    builder.addCase(getThirdPartyDbScanHistory.rejected, (state, action) => {
      state.thirdPartyDbScanHistoryLoading = false;
      state.thirdPartyDbScanHistoryError = action.payload || action.error;
    });

    builder.addCase(getThirdPartyDbLeaksPageable.pending, (state) => {
      state.thirdPartyLeaksLoading = true;
      state.thirdPartyLeaksError = null;
    });
    builder.addCase(getThirdPartyDbLeaksPageable.fulfilled, (state, action) => {
      state.thirdPartyLeaksLoading = false;
      state.thirdPartyLeaksData = action.payload;
      state.thirdPartyLeaksError = null;
    });
    builder.addCase(getThirdPartyDbLeaksPageable.rejected, (state, action) => {
      state.thirdPartyLeaksLoading = false;
      state.thirdPartyLeaksError = action.payload || action.error;
    });

    builder.addCase(getThirdPartyDbLeakAccountsPageable.pending, (state) => {
      state.thirdPartyAccountsLoading = true;
      state.thirdPartyAccountsError = null;
    });
    builder.addCase(getThirdPartyDbLeakAccountsPageable.fulfilled, (state, action) => {
      state.thirdPartyAccountsLoading = false;
      state.thirdPartyAccountsData = action.payload;
      state.thirdPartyAccountsError = null;
    });
    builder.addCase(getThirdPartyDbLeakAccountsPageable.rejected, (state, action) => {
      state.thirdPartyAccountsLoading = false;
      state.thirdPartyAccountsError = action.payload || action.error;
    });

    builder.addCase(getDarkWebLastLeaksHasData.pending, (state) => {
      state.hasLastLeaksLoading = true;
      state.hasLastLeaksError = null;
      state.hasLastLeaksExist = null;
    });
    builder.addCase(getDarkWebLastLeaksHasData.fulfilled, (state, action) => {
      state.hasLastLeaksLoading = false;
      state.hasLastLeaksError = null;
      state.hasLastLeaksExist = !!action.payload?.exist;
    });
    builder.addCase(getDarkWebLastLeaksHasData.rejected, (state, action) => {
      state.hasLastLeaksLoading = false;
      state.hasLastLeaksError = action.payload || action.error;
      state.hasLastLeaksExist = null;
    });

    builder.addCase(getDarkWebLookalikeHasData.pending, (state) => {
      state.hasLookalikeLoading = true;
      state.hasLookalikeError = null;
      state.hasLookalikeExist = null;
    });
    builder.addCase(getDarkWebLookalikeHasData.fulfilled, (state, action) => {
      state.hasLookalikeLoading = false;
      state.hasLookalikeError = null;
      state.hasLookalikeExist = !!action.payload?.exist;
    });
    builder.addCase(getDarkWebLookalikeHasData.rejected, (state, action) => {
      state.hasLookalikeLoading = false;
      state.hasLookalikeError = action.payload || action.error;
      state.hasLookalikeExist = null;
    });

    builder.addCase(getDarkWebThirdPartyDbHasData.pending, (state) => {
      state.hasThirdPartyDbLoading = true;
      state.hasThirdPartyDbError = null;
      state.hasThirdPartyDbExist = null;
    });
    builder.addCase(getDarkWebThirdPartyDbHasData.fulfilled, (state, action) => {
      state.hasThirdPartyDbLoading = false;
      state.hasThirdPartyDbError = null;
      state.hasThirdPartyDbExist = !!action.payload?.exist;
    });
    builder.addCase(getDarkWebThirdPartyDbHasData.rejected, (state, action) => {
      state.hasThirdPartyDbLoading = false;
      state.hasThirdPartyDbError = action.payload || action.error;
      state.hasThirdPartyDbExist = null;
    });

    builder.addCase(getDarkWebDashboardSummary.pending, (state) => {
      state.dashboardSummaryLoading = true;
      state.dashboardSummaryError = null;
    });
    builder.addCase(getDarkWebDashboardSummary.fulfilled, (state, action) => {
      state.dashboardSummaryLoading = false;
      state.dashboardSummary = action.payload;
      state.dashboardSummaryError = null;
    });
    builder.addCase(getDarkWebDashboardSummary.rejected, (state, action) => {
      state.dashboardSummaryLoading = false;
      state.dashboardSummaryError = action.payload || action.error;
    });

    builder.addCase(getDarkWebDashboardLeaksByDataType.pending, (state) => {
      state.dashboardLeaksByDataTypeLoading = true;
      state.dashboardLeaksByDataTypeError = null;
    });
    builder.addCase(getDarkWebDashboardLeaksByDataType.fulfilled, (state, action) => {
      state.dashboardLeaksByDataTypeLoading = false;
      state.dashboardLeaksByDataType = action.payload;
      state.dashboardLeaksByDataTypeError = null;
    });
    builder.addCase(getDarkWebDashboardLeaksByDataType.rejected, (state, action) => {
      state.dashboardLeaksByDataTypeLoading = false;
      state.dashboardLeaksByDataTypeError = action.payload || action.error;
    });

    builder.addCase(getDarkWebDashboardLeaksByBreachType.pending, (state) => {
      state.dashboardLeaksByBreachTypeLoading = true;
      state.dashboardLeaksByBreachTypeError = null;
    });
    builder.addCase(getDarkWebDashboardLeaksByBreachType.fulfilled, (state, action) => {
      state.dashboardLeaksByBreachTypeLoading = false;
      state.dashboardLeaksByBreachType = action.payload;
      state.dashboardLeaksByBreachTypeError = null;
    });
    builder.addCase(getDarkWebDashboardLeaksByBreachType.rejected, (state, action) => {
      state.dashboardLeaksByBreachTypeLoading = false;
      state.dashboardLeaksByBreachTypeError = action.payload || action.error;
    });

    builder.addCase(getDarkWebDashboardLookalikeByDataType.pending, (state) => {
      state.dashboardLookalikeByDataTypeLoading = true;
      state.dashboardLookalikeByDataTypeError = null;
    });
    builder.addCase(getDarkWebDashboardLookalikeByDataType.fulfilled, (state, action) => {
      state.dashboardLookalikeByDataTypeLoading = false;
      state.dashboardLookalikeByDataType = action.payload;
      state.dashboardLookalikeByDataTypeError = null;
    });
    builder.addCase(getDarkWebDashboardLookalikeByDataType.rejected, (state, action) => {
      state.dashboardLookalikeByDataTypeLoading = false;
      state.dashboardLookalikeByDataTypeError = action.payload || action.error;
    });

    builder.addCase(getDarkWebDashboardThirdPartyDatabases.pending, (state) => {
      state.dashboardThirdPartyDatabasesLoading = true;
      state.dashboardThirdPartyDatabasesError = null;
    });
    builder.addCase(getDarkWebDashboardThirdPartyDatabases.fulfilled, (state, action) => {
      state.dashboardThirdPartyDatabasesLoading = false;
      state.dashboardThirdPartyDatabases = action.payload;
      state.dashboardThirdPartyDatabasesError = null;
    });
    builder.addCase(getDarkWebDashboardThirdPartyDatabases.rejected, (state, action) => {
      state.dashboardThirdPartyDatabasesLoading = false;
      state.dashboardThirdPartyDatabasesError = action.payload || action.error;
    });

    builder.addCase(getDarkWebDashboardTopDomainsByLeaks.pending, (state) => {
      state.dashboardTopDomainsByLeaksLoading = true;
      state.dashboardTopDomainsByLeaksError = null;
    });
    builder.addCase(getDarkWebDashboardTopDomainsByLeaks.fulfilled, (state, action) => {
      state.dashboardTopDomainsByLeaksLoading = false;
      state.dashboardTopDomainsByLeaks = action.payload;
      state.dashboardTopDomainsByLeaksError = null;
    });
    builder.addCase(getDarkWebDashboardTopDomainsByLeaks.rejected, (state, action) => {
      state.dashboardTopDomainsByLeaksLoading = false;
      state.dashboardTopDomainsByLeaksError = action.payload || action.error;
    });

    builder.addCase(getDarkWebDashboardActivity.pending, (state) => {
      state.dashboardActivityLoading = true;
      state.dashboardActivityError = null;
    });
    builder.addCase(getDarkWebDashboardActivity.fulfilled, (state, action) => {
      state.dashboardActivityLoading = false;
      state.dashboardActivity = action.payload;
      state.dashboardActivityError = null;
    });
    builder.addCase(getDarkWebDashboardActivity.rejected, (state, action) => {
      state.dashboardActivityLoading = false;
      state.dashboardActivityError = action.payload || action.error;
    });
  },
});

export const {
  clearLeaksData,
  clearScanHistoryData,
  clearLookalikeItemsData,
  clearLookalikeScanHistoryData,
  clearThirdPartyDbScanHistoryData,
  clearThirdPartyLeaksData,
  clearThirdPartyAccountsData,
  clearHasDataFlags,
} = darkWebSlice.actions;

export default darkWebSlice.reducer;
